import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "https://qltsc.aggdxcenter.com/services/api";

async function publicFetch(url, options = {}) {
    const res = await fetch(`${API_BASE}/${url}`, {
        headers: { "Content-Type": "application/json", ...(options.headers || {}) },
        ...options,
    });
    return res.json();
}

// ─────────────────────────────────────────────────────────
// CSS nhúng thẳng — không phụ thuộc Bootstrap / Tailwind
// ─────────────────────────────────────────────────────────
const STYLES = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #f2f4f7; }

  .sp-wrap {
    min-height: 100vh;
    background: #f2f4f7;
    font-family: "Times New Roman", Times, serif;
    font-size: 15px;
    color: #1a1a1a;
    padding-bottom: 60px;
  }

  /* ── Dải màu đỏ quốc kỳ ── */
  .sp-topbar { background: #c0392b; height: 6px; }

  /* ── Header xanh đậm ── */
  .sp-header {
    background: #154360;
    padding: 14px 0 12px;
    color: #fff;
  }
  .sp-header-inner {
    max-width: 780px;
    margin: 0 auto;
    padding: 0 16px;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .sp-logo { width: 54px; height: 54px; flex-shrink: 0; }
  .sp-header-org {
    font-size: 11px;
    letter-spacing: .5px;
    text-transform: uppercase;
    color: #aed6f1;
    margin-bottom: 3px;
  }
  .sp-header-title { font-size: 17px; font-weight: bold; color: #fff; line-height: 1.3; }

  /* ── Layout ── */
  .sp-body { max-width: 780px; margin: 0 auto; padding: 24px 16px 0; }

  /* ── Card ── */
  .sp-card { background: #fff; border: 1px solid #d5d8dc; margin-bottom: 18px; }
  .sp-card-head {
    background: #154360;
    color: #fff;
    padding: 10px 20px;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: .4px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .sp-card-body { padding: 20px 24px; }

  /* ── Tiêu đề phiếu ── */
  .sp-survey-title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    color: #154360;
    margin-bottom: 8px;
    line-height: 1.4;
  }
  .sp-survey-desc {
    font-size: 14px;
    color: #444;
    text-align: center;
    line-height: 1.7;
    border-top: 1px dashed #d5d8dc;
    padding-top: 12px;
    margin-top: 10px;
  }
  .sp-meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #666;
    border-top: 1px dashed #d5d8dc;
    padding-top: 10px;
    margin-top: 12px;
  }

  /* ── Intro box ── */
  .sp-step-intro {
    background: #eaf2f8;
    border-left: 4px solid #154360;
    padding: 10px 14px;
    font-size: 14px;
    color: #2c3e50;
    line-height: 1.8;
    margin-bottom: 20px;
  }

  /* ── Form fields ── */
  .sp-field-label {
    display: block;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 6px;
    color: #1a1a1a;
  }
  .sp-field-label .req { color: #c0392b; margin-left: 2px; }
  .sp-field-label .opt { color: #888; font-weight: normal; font-size: 12px; margin-left: 4px; }
  .sp-input {
    width: 100%;
    border: 1px solid #aab7b8;
    padding: 9px 12px;
    font-size: 14px;
    font-family: inherit;
    color: #1a1a1a;
    background: #fdfefe;
    outline: none;
    transition: border-color .15s;
  }
  .sp-input:focus { border-color: #154360; background: #fff; }
  .sp-input.error { border-color: #c0392b; background: #fef9f9; }
  .sp-err-msg {
    color: #c0392b;
    font-size: 12px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  /* ── Nút ── */
  .sp-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 9px 28px;
    font-size: 14px;
    font-family: inherit;
    font-weight: bold;
    cursor: pointer;
    border: none;
    letter-spacing: .3px;
    transition: background .15s;
  }
  .sp-btn-primary   { background: #154360; color: #fff; }
  .sp-btn-primary:hover:not(:disabled) { background: #1a5276; }
  .sp-btn-primary:disabled { background: #a9cce3; cursor: not-allowed; }
  .sp-btn-secondary { background: #fff; color: #154360; border: 1px solid #154360; }
  .sp-btn-secondary:hover { background: #eaf2f8; }

  /* ── Progress ── */
  .sp-progress-label {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #555;
    margin-bottom: 5px;
  }
  .sp-progress-bar  { height: 5px; background: #d5d8dc; }
  .sp-progress-fill { height: 100%; background: #154360; transition: width .3s ease; }

  /* ── Respondent bar ── */
  .sp-respondent-bar {
    background: #eaf2f8;
    border: 1px solid #aed6f1;
    padding: 9px 16px;
    font-size: 13px;
    color: #154360;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* ── Section title ── */
  .sp-section-title {
    font-size: 13px;
    font-weight: bold;
    color: #154360;
    text-transform: uppercase;
    letter-spacing: .4px;
    border-bottom: 2px solid #154360;
    padding-bottom: 4px;
    margin-bottom: 14px;
  }

  /* ── Câu hỏi ── */
  .sp-q-card { border: 1px solid #d5d8dc; margin-bottom: 14px; background: #fff; }
  .sp-q-card.has-error { border-color: #c0392b; }
  .sp-q-head {
    background: #eaf2f8;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: bold;
    color: #154360;
    border-bottom: 1px solid #d5d8dc;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .sp-q-badge-req {
    font-size: 11px; color: #fff; background: #c0392b;
    padding: 1px 7px; font-weight: normal; letter-spacing: .3px;
  }
  .sp-q-badge-opt {
    font-size: 11px; color: #777; background: #eee;
    padding: 1px 7px; font-weight: normal;
  }
  .sp-q-title { padding: 12px 16px 0; font-size: 14px; font-weight: bold; line-height: 1.6; }
  .sp-q-body  { padding: 10px 16px 14px; }
  .sp-q-err   {
    font-size: 12px; color: #c0392b; margin-bottom: 8px;
    display: flex; align-items: center; gap: 4px;
  }

  /* ── Lựa chọn ── */
  .sp-opt-list { display: flex; flex-direction: column; gap: 6px; }
  .sp-opt-item {
    display: flex; align-items: center; gap: 10px;
    padding: 8px 12px;
    border: 1px solid #d5d8dc;
    background: #fdfefe;
    cursor: pointer; font-size: 14px;
    transition: background .1s, border-color .1s;
    user-select: none;
  }
  .sp-opt-item:hover   { background: #eaf2f8; }
  .sp-opt-item.selected { background: #d6eaf8; border-color: #154360; font-weight: bold; }
  .sp-opt-item input   { accent-color: #154360; width: 15px; height: 15px; flex-shrink: 0; }

  /* ── Ô nhập "Ý kiến khác" ── */
  .sp-other-input-wrap {
    margin-top: 8px;
    margin-left: 25px;
    animation: sp-fadein .18s ease;
  }
  @keyframes sp-fadein { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: none; } }
  .sp-other-input {
    width: 100%;
    border: 1px solid #154360;
    border-left: 3px solid #154360;
    padding: 8px 12px;
    font-size: 14px;
    font-family: inherit;
    color: #1a1a1a;
    background: #eaf2f8;
    outline: none;
    resize: vertical;
    min-height: 64px;
    transition: border-color .15s, background .15s;
  }
  .sp-other-input:focus { background: #fff; border-color: #1a5276; }
  .sp-other-input.error { border-color: #c0392b; background: #fef9f9; }
  .sp-other-label {
    font-size: 12px;
    color: #154360;
    font-style: italic;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  /* ── Textarea ── */
  .sp-textarea {
    width: 100%; border: 1px solid #aab7b8;
    padding: 9px 12px; font-size: 14px; font-family: inherit;
    color: #1a1a1a; resize: vertical; min-height: 80px;
    background: #fdfefe; outline: none;
    transition: border-color .15s;
  }
  .sp-textarea:focus { border-color: #154360; }
  .sp-textarea.error { border-color: #c0392b; }

  /* ── Cảnh báo chưa đủ ── */
  .sp-alert-missing {
    background: #fdedec; border: 1px solid #f1948a;
    border-left: 4px solid #c0392b;
    padding: 10px 14px; font-size: 13px; color: #922b21;
    margin-bottom: 16px;
  }

  /* ── Notice ── */
  .sp-notice {
    background: #fef9e7; border: 1px solid #f9e79f;
    border-left: 4px solid #f39c12;
    padding: 10px 14px; font-size: 13px; color: #7d6608;
    margin-top: 14px; line-height: 1.6;
  }

  /* ── Footer ── */
  .sp-footer {
    max-width: 780px; margin: 20px auto 0;
    padding: 12px 16px 0;
    font-size: 12px; color: #888;
    display: flex; justify-content: space-between; align-items: center;
    border-top: 1px solid #d5d8dc;
  }

  /* ── Màn hình trạng thái (loading / error / success) ── */
  .sp-status-screen {
    min-height: 100vh; background: #f2f4f7;
    display: flex; align-items: center; justify-content: center;
    padding: 20px; font-family: "Times New Roman", Times, serif;
  }
  .sp-status-card {
    background: #fff; border: 1px solid #d5d8dc;
    padding: 48px 40px; text-align: center;
    max-width: 480px; width: 100%;
  }
  .sp-status-icon  { font-size: 52px; margin-bottom: 16px; }
  .sp-status-title { font-size: 20px; font-weight: bold; margin-bottom: 10px; }
  .sp-status-msg   { font-size: 14px; color: #555; line-height: 1.8; }

  /* ── Spinner ── */
  .sp-spinner {
    width: 40px; height: 40px;
    border: 4px solid #d5d8dc; border-top-color: #154360;
    border-radius: 50%; animation: sp-spin 1s linear infinite;
    margin: 0 auto 16px;
  }
  @keyframes sp-spin { to { transform: rotate(360deg); } }

  /* ── Responsive ── */
  @media (max-width: 600px) {
    .sp-header-inner { flex-direction: column; text-align: center; }
    .sp-card-body { padding: 14px 14px; }
    .sp-meta { flex-direction: column; gap: 4px; }
    .sp-footer { flex-direction: column; gap: 6px; text-align: center; }
    .sp-other-input-wrap { margin-left: 10px; }
  }
`;

// ─────────────────────────────────────────────────────────
// Header dùng chung
// ─────────────────────────────────────────────────────────
function Header() {
    return (
        <>
            <div className="sp-topbar" />
            <div className="sp-header">
                <div className="sp-header-inner">
                    <svg className="sp-logo" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="50" cy="50" r="48" fill="#c0392b" stroke="#f9e79f" strokeWidth="3"/>
                        <polygon points="50,18 56,38 76,38 60,50 66,70 50,58 34,70 40,50 24,38 44,38" fill="#f9e79f"/>
                    </svg>
                    <div>
                        <div className="sp-header-org">Cộng hòa xã hội chủ nghĩa Việt Nam — Độc lập – Tự do – Hạnh phúc</div>
                        <div className="sp-header-title">Hệ thống Thăm dò ý kiến</div>
                    </div>
                </div>
            </div>
        </>
    );
}

// ─────────────────────────────────────────────────────────
// Màn hình trạng thái (loading / error / submitted)
// ─────────────────────────────────────────────────────────
function StatusScreen({ icon, title, msg, color }) {
    return (
        <div className="sp-status-screen">
            <style>{STYLES}</style>
            <div className="sp-status-card">
                <div className="sp-status-icon">{icon}</div>
                <div className="sp-status-title" style={{ color }}>{title}</div>
                <div className="sp-status-msg">{msg}</div>
            </div>
        </div>
    );
}

// ─────────────────────────────────────────────────────────
// BƯỚC 1 — Nhập thông tin người tham gia
// ─────────────────────────────────────────────────────────
function StepName({ survey, onConfirm }) {
    const [name, setName]       = useState("");
    const [unit, setUnit]       = useState("");
    const [nameErr, setNameErr] = useState(false);

    function handleStart() {
        if (!name.trim() || name.trim().length < 2) {
            setNameErr(true);
            return;
        }
        onConfirm({ name: name.trim(), unit: unit.trim() });
    }

    return (
        <>
            <Header />
            <div className="sp-body">

                {/* Thông tin phiếu */}
                <div className="sp-card">
                    <div className="sp-card-head">
                        <span>📋</span> Thông tin phiếu khảo sát
                    </div>
                    <div className="sp-card-body">
                        <div className="sp-survey-title">{survey.title}</div>
                        {survey.description && (
                            <div className="sp-survey-desc">{survey.description}</div>
                        )}
                        <div className="sp-meta">
                            <span>Tổng số câu hỏi: <strong>{survey.question_count}</strong></span>
                            <span>Trạng thái: <strong style={{ color: "#1e8449" }}>■ Đang mở</strong></span>
                        </div>
                    </div>
                </div>

                {/* Nhập thông tin */}
                <div className="sp-card">
                    <div className="sp-card-head">
                        <span>👤</span> Thông tin người tham gia khảo sát
                    </div>
                    <div className="sp-card-body">
                        <div className="sp-step-intro">
                            Vui lòng điền đầy đủ họ tên trước khi thực hiện phiếu khảo sát.
                            Thông tin của bạn sẽ được bảo mật và chỉ phục vụ mục đích thống kê nội bộ.
                        </div>

                        <div style={{ marginBottom: 16 }}>
                            <label className="sp-field-label">
                                Họ và tên <span className="req">*</span>
                            </label>
                            <input
                                type="text"
                                className={`sp-input${nameErr ? " error" : ""}`}
                                placeholder="Nhập họ và tên đầy đủ..."
                                value={name}
                                autoFocus
                                onChange={(e) => { setName(e.target.value); if (nameErr) setNameErr(false); }}
                                onKeyDown={(e) => { if (e.key === "Enter") handleStart(); }}
                            />
                            {nameErr && (
                                <div className="sp-err-msg">
                                    <span>▲</span> Vui lòng nhập họ tên (ít nhất 2 ký tự).
                                </div>
                            )}
                        </div>

                        <div style={{ marginBottom: 20 }}>
                            <label className="sp-field-label">
                                Đơn vị / Phòng ban <span className="opt">(không bắt buộc)</span>
                            </label>
                            <input
                                type="text"
                                className="sp-input"
                                placeholder="Ví dụ: Phòng Hành chính – Tổng hợp..."
                                value={unit}
                                onChange={(e) => setUnit(e.target.value)}
                                onKeyDown={(e) => { if (e.key === "Enter") handleStart(); }}
                            />
                        </div>

                        <div className="sp-notice">
                            ⚠ Sau khi nhấn <strong>"Bắt đầu điền phiếu"</strong>, thông tin họ tên sẽ không thể thay đổi.
                            Vui lòng kiểm tra lại trước khi tiếp tục.
                        </div>

                        <div style={{ marginTop: 20, textAlign: "right" }}>
                            <button className="sp-btn sp-btn-primary" onClick={handleStart}>
                                ▶ Bắt đầu điền phiếu
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            <div className="sp-footer">
                <span>Hệ thống Thăm dò ý kiến</span>
                <span>Mọi thông tin được bảo mật theo quy định</span>
            </div>
        </>
    );
}

// ─────────────────────────────────────────────────────────
// Component câu hỏi — có hỗ trợ "Ý kiến khác"
// ─────────────────────────────────────────────────────────
function QuestionCard({ q, idx, answer, otherText, onChange, onOtherChange, showError }) {
    const otherInputRef = useRef(null);

    // Tìm đáp án có allow_other = 1 (nếu có)
    const otherOption = q.options?.find((o) => o.allow_other === 1) || null;

    // Kiểm tra người dùng đang chọn đúng đáp án "ý kiến khác"
    const isOtherSelected = otherOption && String(answer) === String(otherOption.id);

    // Validate lỗi cho câu hỏi
    const hasError = showError && !!q.is_required && (
        answer === undefined || answer === "" ||
        (Array.isArray(answer) && answer.length === 0)
    );

    // Validate lỗi ô nhập ý kiến khác (bắt buộc phải nhập khi đã chọn)
    const otherErr = showError && isOtherSelected && (!otherText || otherText.trim() === "");

    // Focus ô nhập khi chọn "ý kiến khác"
    useEffect(() => {
        if (isOtherSelected && otherInputRef.current) {
            otherInputRef.current.focus();
        }
    }, [isOtherSelected]);

    return (
        <div className={`sp-q-card${hasError ? " has-error" : ""}`}>
            <div className="sp-q-head">
                <span>Câu {idx + 1}</span>
                {q.is_required
                    ? <span className="sp-q-badge-req">Bắt buộc</span>
                    : <span className="sp-q-badge-opt">Không bắt buộc</span>}
            </div>
            <div className="sp-q-title">{q.title}</div>
            <div className="sp-q-body">
                {hasError && (
                    <div className="sp-q-err">
                        <span>▲</span> Vui lòng trả lời câu hỏi này trước khi gửi phiếu.
                    </div>
                )}

                {/* ── Radio ── */}
                {q.type === "radio" && (
                    <div className="sp-opt-list">
                        {q.options.map((opt) => {
                            const sel = String(answer) === String(opt.id);
                            const isOther = opt.allow_other === 1;
                            return (
                                <div key={opt.id}>
                                    <label className={`sp-opt-item${sel ? " selected" : ""}`}>
                                        <input
                                            type="radio"
                                            name={`q_${q.id}`}
                                            value={opt.id}
                                            checked={sel}
                                            onChange={() => {
                                                onChange(q.id, opt.id);
                                                // Xóa text ý kiến khác nếu chuyển sang đáp án khác
                                                if (!isOther) onOtherChange(q.id, "");
                                            }}
                                        />
                                        {isOther ? (
                                            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                                {opt.content}
                                                <span style={{
                                                    fontSize: 11,
                                                    background: "#f39c12",
                                                    color: "#fff",
                                                    padding: "1px 6px",
                                                    fontWeight: "normal",
                                                }}>✏ Tự nhập</span>
                                            </span>
                                        ) : opt.content}
                                    </label>

                                    {/* Ô nhập ý kiến khác — chỉ hiện khi đang chọn đáp án này */}
                                    {isOther && sel && (
                                        <div className="sp-other-input-wrap">
                                            <div className="sp-other-label">
                                                <span>✏</span> Vui lòng nhập ý kiến của bạn:
                                            </div>
                                            <textarea
                                                ref={otherInputRef}
                                                className={`sp-other-input${otherErr ? " error" : ""}`}
                                                placeholder="Nhập ý kiến của bạn tại đây..."
                                                rows={3}
                                                value={otherText || ""}
                                                onChange={(e) => onOtherChange(q.id, e.target.value)}
                                            />
                                            {otherErr && (
                                                <div className="sp-err-msg" style={{ marginTop: 4 }}>
                                                    <span>▲</span> Vui lòng nhập ý kiến của bạn.
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ── Checkbox ── */}
                {q.type === "checkbox" && (
                    <div className="sp-opt-list">
                        {q.options.map((opt) => {
                            const sel = Array.isArray(answer) && answer.map(String).includes(String(opt.id));
                            return (
                                <label key={opt.id} className={`sp-opt-item${sel ? " selected" : ""}`}>
                                    <input
                                        type="checkbox"
                                        value={opt.id}
                                        checked={sel}
                                        onChange={(e) => {
                                            const prev = Array.isArray(answer) ? answer.map(String) : [];
                                            const val  = String(opt.id);
                                            onChange(
                                                q.id,
                                                e.target.checked
                                                    ? [...prev, val]
                                                    : prev.filter((v) => v !== val)
                                            );
                                        }}
                                    />
                                    {opt.content}
                                </label>
                            );
                        })}
                    </div>
                )}

                {/* ── Text ── */}
                {q.type === "text" && (
                    <textarea
                        className={`sp-textarea${hasError ? " error" : ""}`}
                        placeholder="Nhập câu trả lời của bạn..."
                        rows={3}
                        value={answer || ""}
                        onChange={(e) => onChange(q.id, e.target.value)}
                    />
                )}
            </div>
        </div>
    );
}

// ─────────────────────────────────────────────────────────
// BƯỚC 2 — Điền phiếu
// ─────────────────────────────────────────────────────────
function StepForm({ survey, questions, respondent, token, onSubmitted }) {
    const [answers, setAnswers]         = useState({});
    // otherTexts: { [question_id]: string } — lưu nội dung nhập "ý kiến khác"
    const [otherTexts, setOtherTexts]   = useState({});
    const [showError, setShowError]     = useState(false);
    const [submitting, setSubmitting]   = useState(false);

    const answeredCount = questions.filter((q) => {
        const a = answers[q.id];
        if (a === undefined || a === "") return false;
        if (Array.isArray(a) && a.length === 0) return false;
        return true;
    }).length;

    // Kiểm tra câu hỏi radio có option allow_other không
    function getOtherOption(q) {
        return q.options?.find((o) => o.allow_other === 1) || null;
    }

    // Kiểm tra người dùng đang chọn đáp án "ý kiến khác" của câu q
    function isOtherSelected(q) {
        const otherOpt = getOtherOption(q);
        return otherOpt && String(answers[q.id]) === String(otherOpt.id);
    }

    const hasMissing = showError && questions.some((q) => {
        if (!q.is_required) return false;
        const a = answers[q.id];
        if (a === undefined || a === "" || (Array.isArray(a) && a.length === 0)) return true;
        // Nếu chọn "ý kiến khác" mà chưa nhập thì cũng coi là thiếu
        if (isOtherSelected(q) && (!otherTexts[q.id] || otherTexts[q.id].trim() === "")) return true;
        return false;
    });

    function handleAnswer(qId, value) {
        setAnswers((prev) => ({ ...prev, [qId]: value }));
    }

    function handleOtherChange(qId, value) {
        setOtherTexts((prev) => ({ ...prev, [qId]: value }));
    }

    async function handleSubmit() {
        setShowError(true);

        // Tìm câu hỏi bắt buộc chưa trả lời (kể cả ý kiến khác chưa nhập)
        const missing = questions.find((q) => {
            if (!q.is_required) return false;
            const a = answers[q.id];
            if (a === undefined || a === "" || (Array.isArray(a) && a.length === 0)) return true;
            if (isOtherSelected(q) && (!otherTexts[q.id] || otherTexts[q.id].trim() === "")) return true;
            return false;
        });

        if (missing) {
            const el = document.getElementById(`q_anchor_${missing.id}`);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }

        setSubmitting(true);
        try {
            // Xây dựng payload answers — thêm other_text cho từng câu nếu có
            const answersPayload = {};
            questions.forEach((q) => {
                if (answers[q.id] !== undefined) {
                    answersPayload[q.id] = answers[q.id];
                }
            });

            const res = await publicFetch(`public/survey/${token}/submit`, {
                method: "POST",
                body: JSON.stringify({
                    respondent_name: respondent.name,
                    respondent_unit: respondent.unit,
                    answers:         answersPayload,
                    other_texts:     otherTexts,   // { question_id: "nội dung nhập" }
                }),
            });

            if (res.code === 200) {
                onSubmitted();
            } else {
                alert(res.msg || "Gửi phiếu thất bại, vui lòng thử lại.");
            }
        } catch {
            alert("Không thể kết nối đến máy chủ.");
        }
        setSubmitting(false);
    }

    return (
        <>
            <Header />
            <div className="sp-body">

                {/* Thông tin phiếu + progress */}
                <div className="sp-card">
                    <div className="sp-card-head"><span>📋</span> {survey.title}</div>
                    <div className="sp-card-body">
                        {survey.description && (
                            <div style={{ fontSize: 14, color: "#444", marginBottom: 12, lineHeight: 1.7 }}>
                                {survey.description}
                            </div>
                        )}
                        <div className="sp-progress-label">
                            <span>Tiến độ hoàn thành</span>
                            <span>{answeredCount}/{questions.length} câu hỏi</span>
                        </div>
                        <div className="sp-progress-bar">
                            <div className="sp-progress-fill"
                                style={{ width: (questions.length > 0 ? Math.round(answeredCount / questions.length * 100) : 0) + "%" }} />
                        </div>
                    </div>
                </div>

                {/* Người thực hiện */}
                <div className="sp-respondent-bar">
                    <span>👤</span>
                    <span>
                        Người thực hiện: <strong>{respondent.name}</strong>
                        {respondent.unit && <span style={{ color: "#1a5276" }}> — {respondent.unit}</span>}
                    </span>
                </div>

                {/* Nội dung câu hỏi */}
                <div className="sp-section-title">Nội dung phiếu khảo sát</div>

                {questions.map((q, idx) => (
                    <div key={q.id} id={`q_anchor_${q.id}`}>
                        <QuestionCard
                            q={q}
                            idx={idx}
                            answer={answers[q.id]}
                            otherText={otherTexts[q.id]}
                            onChange={handleAnswer}
                            onOtherChange={handleOtherChange}
                            showError={showError}
                        />
                    </div>
                ))}

                {/* Cảnh báo còn thiếu */}
                {hasMissing && (
                    <div className="sp-alert-missing">
                        ▲ Còn câu hỏi bắt buộc chưa được trả lời. Vui lòng kiểm tra lại toàn bộ phiếu trước khi gửi.
                    </div>
                )}

                {/* Hành động */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                    <button
                        className="sp-btn sp-btn-secondary"
                        onClick={() => {
                            if (window.confirm("Xác nhận xóa toàn bộ câu trả lời đã nhập?")) {
                                setAnswers({});
                                setOtherTexts({});
                                setShowError(false);
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }
                        }}
                    >
                        ↺ Nhập lại từ đầu
                    </button>
                    <button
                        className="sp-btn sp-btn-primary"
                        onClick={handleSubmit}
                        disabled={submitting}
                    >
                        {submitting ? "⏳ Đang gửi phiếu..." : "✔ Gửi phiếu khảo sát"}
                    </button>
                </div>

            </div>
            <div className="sp-footer">
                <span>Hệ thống khảo sát nội bộ</span>
                <span>Người thực hiện: <strong>{respondent.name}</strong></span>
            </div>
        </>
    );
}

// ─────────────────────────────────────────────────────────
// MAIN
// ─────────────────────────────────────────────────────────
export default function SurveyPublicPage() {
    const { token } = useParams();

    const [pageStatus, setPageStatus] = useState("loading"); // loading | name | form | submitted | error
    const [errorMsg, setErrorMsg]     = useState("");
    const [survey, setSurvey]         = useState(null);
    const [questions, setQuestions]   = useState([]);
    const [respondent, setRespondent] = useState(null);

    useEffect(() => {
        if (!token) {
            setPageStatus("error");
            setErrorMsg("Đường dẫn không hợp lệ hoặc đã bị xóa.");
            return;
        }
        publicFetch(`public/survey/${token}`)
            .then((res) => {
                if (res.code === 200) {
                    setSurvey({ ...res.survey, question_count: res.questions.length });
                    setQuestions(res.questions);
                    setPageStatus("name");
                } else {
                    setPageStatus("error");
                    setErrorMsg(res.msg || "Không thể tải phiếu khảo sát.");
                }
            })
            .catch(() => {
                setPageStatus("error");
                setErrorMsg("Không thể kết nối đến máy chủ. Vui lòng thử lại sau.");
            });
    }, [token]);

    return (
        <div className="sp-wrap">
            <style>{STYLES}</style>

            {pageStatus === "loading" && (
                <div className="sp-status-screen">
                    <div style={{ textAlign: "center" }}>
                        <div className="sp-spinner" />
                        <div style={{ fontSize: 14, color: "#555", fontFamily: "Times New Roman, serif" }}>
                            Đang tải phiếu khảo sát...
                        </div>
                    </div>
                </div>
            )}

            {pageStatus === "error" && (
                <StatusScreen icon="🔒" title="Không thể truy cập phiếu khảo sát" msg={errorMsg} color="#c0392b" />
            )}

            {pageStatus === "name" && survey && (
                <StepName
                    survey={survey}
                    onConfirm={(info) => {
                        setRespondent(info);
                        setPageStatus("form");
                        window.scrollTo({ top: 0 });
                    }}
                />
            )}

            {pageStatus === "form" && survey && respondent && (
                <StepForm
                    survey={survey}
                    questions={questions}
                    respondent={respondent}
                    token={token}
                    onSubmitted={() => {
                        setPageStatus("submitted");
                        window.scrollTo({ top: 0 });
                    }}
                />
            )}

            {pageStatus === "submitted" && (
                <StatusScreen
                    icon="✅"
                    title="Phiếu khảo sát đã được ghi nhận"
                    msg={
                        <>
                            Cảm ơn <strong>{respondent?.name}</strong> đã hoàn thành phiếu khảo sát.
                            <br /><br />
                            {survey?.title && <em style={{ color: "#154360" }}>"{survey.title}"</em>}
                            <br /><br />
                            <span style={{ fontSize: 13, color: "#888" }}>Bạn có thể đóng trang này.</span>
                        </>
                    }
                    color="#1e8449"
                />
            )}
        </div>
    );
}